/**
 * Where this page is mounted.
 *
 * Master is served at '/'. A PR preview is served at '/pr/<number>-<branch>/', and then the
 * router basename, every same-app navigation that bypasses the router and every file from public/
 * need that prefix. It is read from the URL the document was loaded from, so one build runs
 * unchanged as a preview, in QA and in prod: only where its index.html is served differs. '' anywhere
 * else, which behaves as today.
 *
 * A preview brings its own copy of public/, so a PR that changes an import template or an icon shows
 * it. Never prefix /api/* (the ingress routes it to the backend) or other apps' paths such as
 * /portal, /glow-orders and /glow-pricemotor.
 */
const PREVIEW_MOUNT = /^\/pr\/[0-9]+-[a-z0-9-]+(?=\/|$)/

export const basePath = (): string => PREVIEW_MOUNT.exec(window.location.pathname)?.[0] ?? ''

/** withBase('/login') → '/pr/8165-feat-x/login' on a preview, '/login' on master. Also for public/ files. */
export const withBase = (path: string): string => `${basePath()}${path}`

/** Inverse of withBase for a window.location.pathname. Only strips at a path boundary. */
export const stripBase = (pathname: string): string => {
  const prefix = basePath()
  if (!prefix) return pathname
  if (pathname === prefix) return '/'
  return pathname.startsWith(`${prefix}/`) ? pathname.slice(prefix.length) : pathname
}

/**
 * window.open for a same-app path. Like the SSO link in loginUtils.ts, this is an exit point where a
 * router-relative path becomes a browser-level absolute one, so the new tab opens inside this build's
 * mount rather than on master. Not for /api/* or other apps' paths.
 */
export const openAppTab = (path: string, target = '_blank'): Window | null => window.open(withBase(path), target)
